import React, { useState } from 'react';
import { QuestionMapping } from '../questionOptions';
import './QuickReplies.css';

interface QuickRepliesProps {
  mapping: QuestionMapping;
  onSelect: (answer: string) => void;
  disabled?: boolean;
}

const QuickReplies: React.FC<QuickRepliesProps> = ({ mapping, onSelect, disabled }) => {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [sent, setSent] = useState(false);

  if (sent) return null;

  const handleClick = (option: string) => {
    if (disabled) return;

    if (mapping.multiSelect) {
      setSelected((prev) => {
        const next = new Set(prev);
        if (next.has(option)) {
          next.delete(option);
        } else {
          // "Not sure" is exclusive
          if (option === 'Not sure') {
            return new Set(['Not sure']);
          }
          next.delete('Not sure');
          next.add(option);
        }
        return next;
      });
    } else {
      setSent(true);
      onSelect(option);
    }
  };

  const handleSendMulti = () => {
    if (selected.size === 0 || disabled) return;
    setSent(true);
    onSelect(Array.from(selected).join(', '));
  };

  return (
    <div className="quick-replies">
      <div className="quick-replies-options">
        {mapping.options.map((option) => (
          <button
            key={option}
            className={`quick-reply-btn${selected.has(option) ? ' selected' : ''}`}
            onClick={() => handleClick(option)}
            disabled={disabled}
            type="button"
          >
            {option}
          </button>
        ))}
      </div>
      {mapping.multiSelect && selected.size > 0 && (
        <button
          className="quick-reply-send"
          onClick={handleSendMulti}
          disabled={disabled}
          type="button"
        >
          Send ({selected.size})
        </button>
      )}
    </div>
  );
};

export default QuickReplies;
